import React, {useRef, useState} from "react";
import {ContextMenu} from "@contexts/hooks/useContextMenu.ts";
import {Grid, Menu, MenuItem, Typography, TypographyProps} from "@mui/material";
import {PermissaoAplicacao} from "@models/seguranca/permissaoApp.ts";

import {useAuth} from "@contexts/hooks/UseAuth.tsx";

export interface setContextOptions {
    anchor: HTMLElement | null;
    event?: React.MouseEvent<HTMLElement>;
    options: {
        label: string,
        onClick?: () => void,
        disabled?: boolean,
        hidden?: boolean,
        color?: TypographyProps['color'],
        startIcon?: React.ReactNode,
        endIcon?: React.ReactNode,
        permission?: PermissaoAplicacao | PermissaoAplicacao[]
    }[]
}

/**
 * @param props
 * @see useContextMenu
 */
export function ContextMenuProvider(props: { children: React.ReactNode }) {
    const {hasAccess} = useAuth()
    const [defaultContextMenuEnabled, setDefaultContextMenuEnabled] = useState(false);
    const [options, setOptions] = useState<setContextOptions>({anchor: null, options: []});
    const {anchor} = options;


    const handleSetAnchor = (anchor: HTMLElement | null) => {
        setOptions({...options, anchor});
    }

    const handleSetOptions = (options: setContextOptions) => {
        if (options.options.length === 0) {
            setOptions({anchor: null, options: []});
            return;
        }
        setOptions({
            ...options, options: options.options.map((o) => {
                const noEvent = o.onClick == null;

                return {
                    ...o,
                    disabled: o.disabled || noEvent || (o.permission != null && !hasAccess(o.permission ?? [])),
                    onClick: () => {
                        if (o.onClick != null)
                            o.onClick()
                        handleSetAnchor(null)
                    },
                }
            })
        });
    }

    const menuRef = useRef(null)

    return <ContextMenu.Provider
        value={{setDefaultContextMenuEnabled, defaultContextMenuEnabled, setContextOptions: handleSetOptions}}>
        <div onContextMenu={(e) => {
            if (anchor != null) handleSetAnchor(null)
            if (!defaultContextMenuEnabled) {
                // Garante que o usuario não tenha selecionado nenhum texto antes de tentar abrir,
                // caso ele tenha selecionado algo ele vai abrir o menu normal,
                // por que provavelmente o usuario quer copiar um texto
                // Não apagar, o comportamento tá certo
                const selectedText = window.getSelection()?.toString();
                if (!selectedText || selectedText.trim() === '') {
                    e.preventDefault()
                }
            }
        }}>
            {props.children}
            <Menu ref={menuRef} open={Boolean(anchor)} anchorEl={anchor}
                  anchorPosition={{
                      left: options.event?.clientX ?? 0,
                      top: options.event?.clientY ?? 0,
                  }}
                  anchorReference={options.event != null ? 'anchorPosition' : 'anchorEl'}
                  onClose={() => handleSetAnchor(null)}>
                {options.options.map((opt, index) => {
                    return (
                        <MenuItem key={index}
                                  dense={false}
                                  onClick={opt.onClick}
                                  disabled={opt.disabled}
                                  color={'primary'}
                                  hidden={opt.hidden}>
                            <Grid container alignItems={'center'} gap={1}>
                                {opt.startIcon &&
                                    <Typography fontSize={'small'} color={opt.color}>{opt.startIcon}</Typography>}
                                <Typography fontSize={'small'} color={opt.color}>{opt.label}</Typography>
                                {opt.endIcon &&
                                    <Typography fontSize={'small'} color={opt.color}>{opt.endIcon}</Typography>}
                            </Grid>
                        </MenuItem>)
                })}
            </Menu>
        </div>
    </ContextMenu.Provider>
}